import { render, staticRenderFns } from "./SalesOrderPreview.vue?vue&type=template&id=3bff65e3&"
import script from "./SalesOrderPreview.vue?vue&type=script&lang=js&"
export * from "./SalesOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports